import React from "react";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";
import { isAnswer } from "utils/formatter";

const browserStyles = theme => ({
  container: {
    margin: 20,
    padding: 20,
    backgroundColor: theme.palette.answer.backgroundColor,
    height: 570,
    position: "relative"
  },
  attrLabelDiv: {
    margin: "20px 40px"
  },
  attrLabel: {
    fontSize: "1.6rem",
    borderBottom: `5px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 20px"
  },
  description: {
    border: `10px solid ${theme.palette.answer.borderColor}`,
    backgroundColor: "white",
    margin: "40px 40px 0",
    padding: 70,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    textAlign: "center",
    fontSize: "1.4rem"
  },
  annotate: {
    textAlign: "right",
    margin: "5px 40px",
    color: theme.palette.primary.main,
    fontSize: "0.9rem"
  },
  nextBtnDiv: {
    textAlign: "center"
  },
  nextBtn: {
    marginTop: 70
  },
  footer: {
    position: "absolute",
    bottom: 15,
    margin: 10
  }
});

const mobileStyles = theme => ({
  container: {
    margin: 10,
    padding: 10,
    backgroundColor: theme.palette.answer.backgroundColor
  },
  attrLabelDiv: {
    marginBottom: 20
  },
  attrLabel: {
    borderBottom: `2px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 10px"
  },
  main: {
    minHeight: 190
  },
  description: {
    border: `2px solid ${theme.palette.answer.borderColor}`,
    backgroundColor: "white",
    margin: 10,
    padding: 10,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    textAlign: "center"
  },
  annotate: {
    margin: 10,
    color: theme.palette.primary.main,
    fontSize: "0.8rem"
  },
  nextBtnDiv: {
    textAlign: "center"
  },
  nextBtn: {
    marginTop: 20
  }
});

class AttributeReady extends React.Component {
  componentWillMount() {
    const { answerToken } = this.props.answerHeader;
    const { locale } = this.props.answerResult;

    if (answerToken) {
      this.props.fetchAttributeReady(answerToken, locale.id);

      if (isAnswer()) {
        window.addEventListener("beforeunload", this.showReloadAlert);
      }
    } else {
      // answerTokenなしは認証エラー
      this.props.showErrorDialog();
    }
  }

  componentWillUnmount() {
    if (isAnswer()) {
      window.removeEventListener("beforeunload", this.showReloadAlert);
    }
  }

  showReloadAlert(e) {
    e.returnValue = "回答は削除されます。";
  }

  render() {
    const { classes, answerHeader, attributeReady } = this.props;
    // state
    const { isEffecting } = answerHeader;
    const { surveyLocale } = attributeReady;
    // action
    const { handleNext, handleBack } = this.props;

    return (
      <Paper className={classes.container}>
        <div className={classes.attrLabelDiv}>
          <span className={classes.attrLabel}>属性</span>
        </div>

        <div className={classes.main}>
          <div className={classes.description}>
            {surveyLocale.answerDescription}
          </div>
          <div className={classes.annotate}>
            ※全てご回答いただくと全問の確認画面が表示されます。<br />
            ※確認画面にて各回答の修正も可能です。
          </div>
        </div>

        <div className={classes.nextBtnDiv}>
          <Button
            className={classes.nextBtn}
            raised
            onClick={() => {
              if (!isEffecting) {
                handleNext();
              }
            }}
          >
            次へ
          </Button>
        </div>

        <div className={classes.footer}>
          <Button
            raised
            dense
            onClick={() => {
              if (!isEffecting) {
                handleBack();
              }
            }}
          >
            前へ
          </Button>
        </div>
      </Paper>
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  AttributeReady
);



// WEBPACK FOOTER //
// ./src/components/answer/AttributeReady.jsx